import React from 'react';
import './LibraryPage.css';
import Navbar from '../components/navbar';
import CTAButton from '../components/sticky-button';
import Footer from '../components/Footer';
import PageHeader from '../about/PageHeader';

const LibraryPage = () => {
  return (
    <>
      <Navbar />
      <CTAButton />

      <div className="edulib-page-container">
        <PageHeader
          title="About Library"
          crumbs={[
            { label: "Home", href: "/" },
            { label: "About Library" },
          ]}
        />

        {/* Info Section (Blue Boxes) */}
        <div className="edulib-info-section">
          <div className="edulib-container edulib-info-grid">

            {/* Card 1: Learning Resources */}
            <div className="edulib-info-box">
              <div className="edulib-box-icon-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                  <line x1="16" y1="13" x2="8" y2="13"></line>
                  <line x1="16" y1="17" x2="8" y2="17"></line>
                  <polyline points="10 9 9 9 8 9"></polyline>
                </svg>
              </div>
              <div className="edulib-box-content">
                <h3 className="edulib-box-title">Learning Resources</h3>
                <p className="edulib-box-text">
                  TIMSCDR continuously updates its learning resources by increasing the number of books and other reading materials such as journals, magazines, audio-visual materials, and newspapers. Easy access to all library resources by the students is ensured.
                </p>
              </div>
            </div>

            {/* Card 2: Infrastructure */}
            <div className="edulib-info-box">
              <div className="edulib-box-icon-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 21h18"></path>
                  <path d="M5 21V7"></path>
                  <path d="M19 21V7"></path>
                  <path d="M4 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v0"></path>
                  <path d="M12 2a4 4 0 0 0-4 4"></path>
                  <path d="M12 2a4 4 0 0 1 4 4"></path>
                  <line x1="8" y1="11" x2="8" y2="16"></line>
                  <line x1="12" y1="11" x2="12" y2="16"></line>
                  <line x1="16" y1="11" x2="16" y2="16"></line>
                </svg>
              </div>
              <div className="edulib-box-content">
                <h3 className="edulib-box-title">Infrastructure</h3>
                <p className="edulib-box-text">
                  TIMSCDR Library is located on the 2nd floor. It is air-conditioned and has sections such as:
                </p>
                <ul className="edulib-box-list">
                  <li>
                    <svg className="edulib-check-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
                    Digital Library & Reading Room
                  </li>
                  <li>
                    <svg className="edulib-check-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
                    Circulation Counter
                  </li>
                  <li>
                    <svg className="edulib-check-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
                    Book Stacking Area (Capacity: 15,000 Books)
                  </li>
                  <li>
                    <svg className="edulib-check-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
                    Subject wise labelled cupboards
                  </li>
                  <li>
                    <svg className="edulib-check-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
                    CDs/DVDs procured with books & periodicals
                  </li>
                  <li>
                    <svg className="edulib-check-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
                    Display rack for journals and magazines
                  </li>
                  <li>
                    <svg className="edulib-check-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
                    Student project reports for research needs
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Collection Section */}
        <div className="edulib-collection-section">
          <div className="edulib-container">
            <h2 className="edulib-section-title">Our Collection</h2>
            <div className="edulib-collection-grid">

              {/* Card 1: Text Books */}
              <div className="edulib-collection-card">
                <div className="edulib-collection-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
                    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
                  </svg>
                </div>
                <div className="edulib-collection-number">13,760+</div>
                <div className="edulib-collection-label">Books</div>
              </div>

              {/* Card 2: Reference Books */}
              <div className="edulib-collection-card">
                <div className="edulib-collection-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
                    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
                  </svg>
                </div>
                <div className="edulib-collection-number">900+</div>
                <div className="edulib-collection-label">Reference Books</div>
              </div>

              {/* Card 3: e-Books */}
              <div className="edulib-collection-card">
                <div className="edulib-collection-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect>
                    <line x1="12" y1="18" x2="12.01" y2="18"></line>
                  </svg>
                </div>
                <div className="edulib-collection-number">4,600+</div>
                <div className="edulib-collection-label">e-Books</div>
              </div>

              {/* Card 4: National and International Journals */}
              <div className="edulib-collection-card">
                <div className="edulib-collection-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
                    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
                    <path d="M12 6h4"></path>
                    <path d="M12 10h4"></path>
                  </svg>
                </div>
                <div className="edulib-collection-number">6</div>
                <div className="edulib-collection-label">National and International Journals</div>
              </div>

              {/* Card 5: Springer Nature (Replaced IEEE) */}
              <div className="edulib-collection-card">
                <div className="edulib-collection-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                    <line x1="2" y1="20" x2="22" y2="20"></line>
                  </svg>
                </div>
                <div className="edulib-collection-number">103</div>
                <div className="edulib-collection-label">Springer Nature 1 Computer Science (e-journals)</div>
              </div>

              {/* Card 6: Magazines */}
              <div className="edulib-collection-card">
                <div className="edulib-collection-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"></path>
                    <path d="M9 3v18"></path>
                    <path d="M3 9h18"></path>
                  </svg>
                </div>
                <div className="edulib-collection-number">3</div>
                <div className="edulib-collection-label">Magazines</div>
              </div>

              {/* Card 7: Newspapers */}
              <div className="edulib-collection-card">
                <div className="edulib-collection-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14 2 14 8 20 8"></polyline>
                    <line x1="16" y1="13" x2="8" y2="13"></line>
                    <line x1="16" y1="17" x2="8" y2="17"></line>
                    <polyline points="10 9 9 9 8 9"></polyline>
                  </svg>
                </div>
                <div className="edulib-collection-number">6</div>
                <div className="edulib-collection-label">Newspapers (include English, Hindi and Marathi)</div>
              </div>

            </div>
          </div>
        </div>

      </div>

      <Footer />
    </>
  );
};

export default LibraryPage;